import { ICreateDependenteUseCase } from "../../../presentation/useCases/create/create_dependente_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateDependenteUseCase
 */

export class CreateDependenteUseCase implements ICreateDependenteUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createDependente(
    idFuncionario: number,
    nome: string,
    dataNascimento: Date | null,
    cpf: string,
    rg: string,
    grauParentesco: string,
  ): Promise<void> {
    await this.repository.createDependente(
      idFuncionario,
      nome,
      grauParentesco,
      rg,
      cpf,
      dataNascimento ? dataNascimento.toISOString() : null,
    );
  }
}